export class NecessaryInfoLackingError extends Error {}
export class PositionNotExistsError extends Error {}
export class SNInconsistentError extends Error {}
export class BuildIdNotFoundError extends Error {}
export class DeviceAlreadyExistsError extends Error {}
export class SNIMEINotMatchError extends Error {}
export class IMEIStatusError extends Error {}
export class GateNumberNotMatchError extends Error {}
